export function enrichEventAttendeesWithChampionshipDetails(
  eventAttendees = [],
  championshipAttendees = [],
) {
  if (!Array.isArray(eventAttendees)) return []
  if (
    !Array.isArray(championshipAttendees) ||
    championshipAttendees.length === 0
  ) {
    return eventAttendees
  }

  const championshipAttendeesByUserId = new Map(
    championshipAttendees.map((attendee) => [attendee.userId, attendee]),
  )

  return eventAttendees.map((eventAttendee) => {
    const championshipAttendee = championshipAttendeesByUserId.get(
      eventAttendee.userId,
    )

    if (!championshipAttendee) return eventAttendee

    return {
      ...eventAttendee,
      nickname: championshipAttendee.nickname ?? null,
      team: championshipAttendee.team,
      carClass: championshipAttendee.carClass,
      split: championshipAttendee.split,
    }
  })
}
